import { Children, ReactNode, isValidElement } from "react";
import { Option } from "../Option";
import { OptionItem } from "../OptionItem";

/**
 * Gets the options from the specified children.
 * @param children The children to get the options from.
 * @returns The array of options.
 */
export function getOptions(children: ReactNode | undefined): ReadonlyArray<OptionItem> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;
      if (child.type !== Option) {
        console.log("MultiSelectDropdown ignoring unsupported child component.");
        return null;
      }

      const { props } = child;
      const { children, label, value, type, inverted } = props;

      return { type: "option", label: children ?? label, value, tagType: type, tagInverted: inverted } as OptionItem;
    })?.filter((option) => !!option) ?? []
  );
}
